import { toQueryString } from "./toQueryString";

interface SignInParams {
  params?: Record<string, any>;
}

interface AuthenticateWithProviderParams {
  communityId: string;
  provider: string;
}

export const userPaths = {
  signIn: ({ params = {} }: SignInParams = {}) =>
    `/users/sign_in?${toQueryString(params)}`,
  authenticateWithProvider: ({
    provider,
    communityId,
  }: AuthenticateWithProviderParams) =>
    `/users/auth/${provider}?community_id=${communityId}`,
};
